import React from "react";
import "./styles.scss";

const Full = ({ children, ...rest }) => {
	return (
		<div>
			{children}
		</div>
	);
};

export default Full;
